"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCybertronTheme = exports.monospaceInputStyles = exports.getInlineInputStyles = exports.getAccessibleForegroundColor = exports.MONOSPACE_FONT_FAMILY = exports.DENSE_MENU_ITEM_HEIGHT = exports.DEFAULT_MENU_ITEM_HEIGHT = exports.SPACING_FACTOR = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const chroma_js_1 = __importDefault(require("chroma-js"));
require("@sbu/fonts.labgrotesque");
const material_1 = require("@mui/material");
const info_svg_1 = __importDefault(require("@sbu/assets.svg/src/info.svg"));
const malicious_svg_1 = __importDefault(require("@sbu/assets.svg/src/malicious.svg"));
const single_chevron_left_svg_1 = __importDefault(require("@sbu/assets.svg/src/single-chevron-left.svg"));
const single_chevron_right_svg_1 = __importDefault(require("@sbu/assets.svg/src/single-chevron-right.svg"));
const success_svg_1 = __importDefault(require("@sbu/assets.svg/src/success.svg"));
const suspicious_svg_1 = __importDefault(require("@sbu/assets.svg/src/suspicious.svg"));
const yama_ds_components_1 = require("@sumologic/yama-ds-components");
exports.SPACING_FACTOR = 8;
exports.DEFAULT_MENU_ITEM_HEIGHT = exports.SPACING_FACTOR * 5;
exports.DENSE_MENU_ITEM_HEIGHT = exports.SPACING_FACTOR * 3.5;
exports.MONOSPACE_FONT_FAMILY = "'Lab Grotesque Mono', 'Courier New', monospace";
const getAccessibleForegroundColor = (backgroundColor) => {
    return (0, chroma_js_1.default)(backgroundColor).luminance() < 0.18
        ? 'common.white'
        : 'common.black';
};
exports.getAccessibleForegroundColor = getAccessibleForegroundColor;
const getInlineInputStyles = (_label) => {
    return {
        fontSize: 'inherit',
        [`.${material_1.inputClasses.input}.${material_1.selectClasses.select}, .${material_1.inputClasses.input}.${material_1.autocompleteClasses.input}, .${material_1.inputBaseClasses.input}.${material_1.inputClasses.input}`]: {
            color: 'tokens.YamaLinkPrimaryDefaultColor',
            paddingTop: 0,
            paddingBottom: 0,
            lineHeight: 1.5,
        },
        [`&.${material_1.inputBaseClasses.root}.${material_1.inputClasses.root}`]: {
            marginTop: 0,
        },
        [`.${material_1.selectClasses.icon}`]: {
            top: 'calc(75% - 0.5em)',
        },
    };
};
exports.getInlineInputStyles = getInlineInputStyles;
exports.monospaceInputStyles = {
    fontFamily: exports.MONOSPACE_FONT_FAMILY,
};
// TODO: Adjust h5 and h6 styling when appropriate. For now, do not use
const getCybertronTheme = (mode) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25;
    const yamaTheme = mode === 'dark' ? yama_ds_components_1.darkTheme : yama_ds_components_1.lightTheme;
    const { body1, body2 } = yamaTheme.typography;
    const { background, text, error, info, primary, secondary, success, warning, tokens: yamaTokens, } = yamaTheme.palette;
    const InfoIcon = (_a) => {
        var { sx: sxProps } = _a, restProps = __rest(_a, ["sx"]);
        return ((0, jsx_runtime_1.jsx)(material_1.SvgIcon, Object.assign({ "aria-hidden": true, component: info_svg_1.default, sx: Object.assign({ color: yamaTokens.YamaTypographyColorIcon, height: 14, width: 14 }, sxProps) }, restProps)));
    };
    const SuccessIcon = (_a) => {
        var { sx: sxProps } = _a, restProps = __rest(_a, ["sx"]);
        return ((0, jsx_runtime_1.jsx)(material_1.SvgIcon, Object.assign({ "aria-hidden": true, component: success_svg_1.default, sx: Object.assign({ color: 'success.main', height: 14, width: 14 }, sxProps) }, restProps)));
    };
    const MaliciousIcon = (_a) => {
        var { sx: sxProps } = _a, restProps = __rest(_a, ["sx"]);
        return ((0, jsx_runtime_1.jsx)(material_1.SvgIcon, Object.assign({ "aria-hidden": true, component: malicious_svg_1.default, sx: Object.assign({ color: 'warning.main', height: 14, width: 14 }, sxProps) }, restProps)));
    };
    const SuspiciousIcon = (_a) => {
        var { sx: sxProps } = _a, restProps = __rest(_a, ["sx"]);
        return ((0, jsx_runtime_1.jsx)(material_1.SvgIcon, Object.assign({ "aria-hidden": true, component: suspicious_svg_1.default, sx: Object.assign({ color: 'error.main', height: 14, width: 14 }, sxProps) }, restProps)));
    };
    // Overrides ===================================================================
    const MuiAlert = {
        defaultProps: {
            variant: 'standard',
            iconMapping: {
                info: (0, jsx_runtime_1.jsx)(InfoIcon, {}),
                success: (0, jsx_runtime_1.jsx)(SuccessIcon, {}),
                warning: (0, jsx_runtime_1.jsx)(MaliciousIcon, {}),
                error: (0, jsx_runtime_1.jsx)(SuspiciousIcon, {}),
            },
        },
        styleOverrides: {
            root: Object.assign(Object.assign({}, body2), { color: text.primary, display: 'flex', alignItems: 'center', [`&.${material_1.paperClasses.root}`]: {
                    backgroundColor: background.paper,
                    padding: `0 ${exports.SPACING_FACTOR * 2}px 0 0`,
                    borderLeft: '4px solid',
                } }),
            icon: {
                marginRight: exports.SPACING_FACTOR * 0.75,
                marginLeft: exports.SPACING_FACTOR * 2,
                padding: `${exports.SPACING_FACTOR}px 0px`,
            },
        },
        variants: [
            {
                props: { severity: 'info' },
                style: {
                    [`&.${material_1.alertClasses.icon}`]: {
                        color: yamaTokens.YamaTypographyColorIcon,
                    },
                    [`&.${material_1.paperClasses.root}`]: {
                        borderLeftColor: yamaTokens.YamaTypographyColorIcon,
                    },
                },
            },
            {
                props: { severity: 'error' },
                style: {
                    [`&.${material_1.alertClasses.icon}`]: {
                        color: error.main,
                    },
                    [`&.${material_1.paperClasses.root}`]: {
                        borderLeftColor: error.main,
                    },
                },
            },
            {
                props: { severity: 'warning' },
                style: {
                    [`&.${material_1.alertClasses.icon}`]: {
                        color: warning.main,
                    },
                    [`&.${material_1.paperClasses.root}`]: {
                        borderLeftColor: warning.main,
                    },
                },
            },
            {
                props: { severity: 'success' },
                style: {
                    [`&.${material_1.alertClasses.icon}`]: {
                        color: success.main,
                    },
                    [`&.${material_1.paperClasses.root}`]: {
                        borderLeftColor: success.main,
                    },
                },
            },
        ],
    };
    const MuiBadge = {
        defaultProps: {
            variant: 'dot',
        },
        styleOverrides: {
            dot: {
                height: 0.75 * exports.SPACING_FACTOR,
                minWidth: 0.75 * exports.SPACING_FACTOR,
            },
        },
    };
    const MuiBreadcrumbs = {
        defaultProps: {
            separator: ((0, jsx_runtime_1.jsx)(material_1.SvgIcon, { "aria-hidden": true, component: single_chevron_right_svg_1.default, sx: {
                    color: yamaTokens.YamaTypographyColorIcon,
                    height: 12,
                    width: 12,
                } })),
        },
        styleOverrides: {
            li: {
                color: text.primary,
                [`.${material_1.typographyClasses.root}.${material_1.linkClasses.root}`]: {
                    '&, &:visited': {
                        color: yamaTokens.YamaLinkPrimaryDefaultColor,
                        '&:hover, &:focus, &:focus-visible': {
                            color: yamaTokens.YamaLinkPrimaryHoverColor,
                        },
                    },
                },
            },
        },
    };
    const MuiCard = {
        styleOverrides: {
            root: {
                backgroundImage: 'none',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                bgcolor: background.paper,
                border: '1px solid',
                borderColor: yamaTokens.YamaBorderVariantLowcontrastColor,
            },
        },
    };
    const MuiCardActions = {
        styleOverrides: {
            root: {
                backgroundColor: background.default,
                borderTop: '1px solid',
                borderColor: yamaTokens.YamaBorderVariantLowcontrastColor,
                flexDirection: 'column',
            },
        },
    };
    const MuiCardContent = {
        styleOverrides: {
            root: {
                padding: '16px 40px 0',
            },
        },
    };
    const MuiCssBaseline = {
        styleOverrides: {
            html: {
                fontSize: 14,
            },
            body: {
                fontSize: 14,
                lineHeight: 1.1,
            },
            a: {
                fontSize: '0.875rem',
                transition: 'color 0.3s',
                textDecoration: 'none',
                backgroundColor: 'transparent',
                ':hover': {
                    color: yamaTokens.YamaLinkPrimaryHoverColor,
                    textDecoration: 'none',
                },
            },
        },
    };
    const MuiInput = {
        styleOverrides: {
            root: Object.assign(Object.assign({}, body1), { [`&.${material_1.inputClasses.disabled}`]: {
                    opacity: 0.5,
                    color: text.secondary,
                    '-webkit-text-fill-color': text.secondary,
                    '&:before': {
                        borderBottomColor: text.secondary,
                        borderBottomStyle: 'solid',
                    },
                }, [`.${material_1.inputClasses.input}:focus`]: {
                    backgroundColor: 'transparent',
                } }),
            underline: {
                [`&:not(.${material_1.inputClasses.disabled})`]: {
                    '&:before': {
                        borderBottomColor: info.light,
                    },
                    '&:hover': {
                        '&:before': {
                            borderBottomColor: info.light,
                        },
                    },
                    [`&.${material_1.inputClasses.focused}, &:focus`]: {
                        '&:before': {
                            borderBottomColor: info.light,
                        },
                        '&:after': {
                            borderBottomColor: info.light,
                        },
                        [`&.${material_1.inputClasses.error}`]: {
                            '&:before': {
                                borderBottomColor: error.main,
                            },
                            '&:after': {
                                borderBottomColor: error.main,
                            },
                        },
                    },
                    [`&:active`]: {
                        '&:before': {
                            borderBottomColor: info.main,
                        },
                        '&:after': {
                            borderBottomColor: info.main,
                        },
                        [`&.${material_1.inputClasses.error}`]: {
                            '&:before': {
                                borderBottomColor: error.main,
                            },
                            '&:after': {
                                borderBottomColor: error.main,
                            },
                        },
                    },
                    [`&.${material_1.inputClasses.error}`]: {
                        '&:before': {
                            borderBottomColor: error.main,
                        },
                        '&:after': {
                            borderBottomColor: error.main,
                        },
                    },
                },
                [`&.${material_1.inputClasses.disabled}`]: {
                    opacity: 0.5,
                    '&:before': {
                        borderBottomColor: text.secondary,
                    },
                },
            },
        },
    };
    const MuiInputBase = {
        styleOverrides: {
            root: {
                [`&.${material_1.inputClasses.root}`]: {
                    marginTop: 2.75 * exports.SPACING_FACTOR,
                },
            },
        },
    };
    const MuiPaginationItem = {
        defaultProps: {
            slots: {
                previous: single_chevron_left_svg_1.default,
                next: single_chevron_right_svg_1.default,
            },
        },
        styleOverrides: {
            root: {
                '& svg': {
                    height: 16,
                    width: 16,
                    color: yamaTokens.YamaTypographyColorIcon,
                },
                borderRadius: '2px',
                [`&.${material_1.paginationItemClasses.selected}`]: {
                    color: text.primary,
                    backgroundColor: secondary.light,
                },
                [`&:not(.${material_1.paginationItemClasses.selected})`]: {
                    color: text.secondary,
                },
            },
        },
    };
    const MuiRadio = {
        defaultProps: {
            disableRipple: true,
            disableFocusRipple: true,
            disableTouchRipple: true,
        },
        styleOverrides: {
            root: {
                [`&.${material_1.radioClasses.root}`]: {
                    borderWidth: exports.SPACING_FACTOR / 4,
                    paddingTop: exports.SPACING_FACTOR / 2,
                    paddingBottom: exports.SPACING_FACTOR / 2,
                    gap: exports.SPACING_FACTOR,
                },
                [`&:hover, &:focus, &:focus-visible`]: {
                    color: primary.main,
                },
                [`&.${material_1.radioClasses.checked}`]: {
                    color: primary.main,
                    [`&:hover, &:focus, &:focus-visible`]: {
                        color: primary.light,
                    },
                },
            },
        },
    };
    const MuiToggleButton = {
        defaultProps: {
            disableFocusRipple: true,
            disableRipple: true,
            size: 'medium',
        },
        styleOverrides: {
            root: ({ ownerState }) => (Object.assign(Object.assign(Object.assign(Object.assign({ border: '1px solid', borderColor: secondary.main, borderRadius: 0, color: primary.contrastText, textTransform: 'none', lineHeight: 'normal', fontWeight: 400, [`&.${material_1.toggleButtonClasses.disabled}`]: {
                    opacity: 0.5,
                } }, (ownerState.size === 'small' && {
                paddingLeft: exports.SPACING_FACTOR * 1.5,
                paddingRight: exports.SPACING_FACTOR * 1.5,
                paddingTop: 0.75 * exports.SPACING_FACTOR,
                paddingBottom: 0.75 * exports.SPACING_FACTOR,
                fontSize: '1rem',
            })), (ownerState.size === 'medium' && {
                paddingLeft: exports.SPACING_FACTOR * 3,
                paddingRight: exports.SPACING_FACTOR * 3,
                paddingTop: 0.75 * exports.SPACING_FACTOR,
                paddingBottom: 0.75 * exports.SPACING_FACTOR,
                fontSize: '1rem',
                // Based on designs, the min width of the button is
                // minimum 112px content width +  1 * 1px borders + 2 * left and right padding
                minWidth: 114 + exports.SPACING_FACTOR * 3 * 2,
            })), (ownerState.color === 'standard' && {
                color: secondary.contrastText,
                svg: {
                    color: secondary.contrastText,
                    fill: secondary.contrastText,
                    '& path': {
                        fill: secondary.contrastText,
                    },
                },
                [`&.${material_1.toggleButtonClasses.selected}`]: {
                    backgroundColor: primary.main,
                },
                [`&.${material_1.toggleButtonClasses.selected}, &:hover, &:focus`]: {
                    color: primary.contrastText,
                    svg: {
                        color: primary.contrastText,
                        fill: primary.contrastText,
                        '& path': {
                            fill: primary.contrastText,
                        },
                    },
                },
                [`&.${material_1.toggleButtonClasses.selected}:hover,&.${material_1.toggleButtonClasses.selected}:focus,  &:hover, &:focus`]: {
                    backgroundColor: primary.light,
                },
            })), (ownerState.color === 'secondary' && {
                color: secondary.contrastText,
                svg: {
                    color: secondary.contrastText,
                    fill: secondary.contrastText,
                    '& path': {
                        fill: secondary.contrastText,
                    },
                },
                [`&.${material_1.toggleButtonClasses.selected}`]: {
                    color: secondary.contrastText,
                    backgroundColor: secondary.main,
                },
                [`&.${material_1.toggleButtonClasses.selected}:hover,&.${material_1.toggleButtonClasses.selected}:focus,  &:hover, &:focus`]: {
                    backgroundColor: secondary.light,
                },
            }))),
        },
    };
    const MuiPopper = {
        // This type isn't provided with our current MUI version.
        // Remove when upgrading to MUI version 5.14.13 (when it was fixed) or newer.
        // @ts-ignore
        styleOverrides: {
            root: {
                '&.MuiPopper-root': {
                    // Use 1300 to match modal/other menus:
                    // https://mui.com/material-ui/customization/z-index/
                    zIndex: 1300,
                },
            },
        },
    };
    const MuiTypography = {
        defaultProps: {
            variantMapping: {
                subtitle1: 'p',
                subtitle2: 'p',
                inherit: 'p',
                code: 'code',
            },
        },
        styleOverrides: {
            root: {
                padding: 0,
            },
        },
        variants: (_b = (_a = yamaTheme.components) === null || _a === void 0 ? void 0 : _a.MuiTypography) === null || _b === void 0 ? void 0 : _b.variants,
    };
    return (0, material_1.createTheme)({
        components: {
            MuiAccordion: (_c = yamaTheme === null || yamaTheme === void 0 ? void 0 : yamaTheme.components) === null || _c === void 0 ? void 0 : _c.MuiAccordion,
            MuiAccordionDetails: (_d = yamaTheme === null || yamaTheme === void 0 ? void 0 : yamaTheme.components) === null || _d === void 0 ? void 0 : _d.MuiAccordionDetails,
            MuiAccordionSummary: (_e = yamaTheme === null || yamaTheme === void 0 ? void 0 : yamaTheme.components) === null || _e === void 0 ? void 0 : _e.MuiAccordionSummary,
            MuiAlert,
            MuiAutocomplete: (_f = yamaTheme.components) === null || _f === void 0 ? void 0 : _f.MuiAutocomplete,
            MuiBackdrop: (_g = yamaTheme.components) === null || _g === void 0 ? void 0 : _g.MuiBackdrop,
            MuiBadge,
            MuiButtonBase: (_h = yamaTheme.components) === null || _h === void 0 ? void 0 : _h.MuiButtonBase,
            MuiButton: (_j = yamaTheme.components) === null || _j === void 0 ? void 0 : _j.MuiButton,
            MuiBreadcrumbs,
            MuiCard,
            MuiCardActions,
            MuiCardContent,
            MuiCheckbox: (_k = yamaTheme === null || yamaTheme === void 0 ? void 0 : yamaTheme.components) === null || _k === void 0 ? void 0 : _k.MuiCheckbox,
            MuiChip: (_l = yamaTheme === null || yamaTheme === void 0 ? void 0 : yamaTheme.components) === null || _l === void 0 ? void 0 : _l.MuiChip,
            MuiCssBaseline,
            MuiDialog: (_m = yamaTheme.components) === null || _m === void 0 ? void 0 : _m.MuiDialog,
            MuiDialogActions: (_o = yamaTheme.components) === null || _o === void 0 ? void 0 : _o.MuiDialogActions,
            MuiDialogContent: (_p = yamaTheme.components) === null || _p === void 0 ? void 0 : _p.MuiDialogContent,
            MuiDialogContentText: (_q = yamaTheme.components) === null || _q === void 0 ? void 0 : _q.MuiDialogContentText,
            MuiDialogTitle: (_r = yamaTheme.components) === null || _r === void 0 ? void 0 : _r.MuiDialogTitle,
            MuiFormGroup: (_s = yamaTheme === null || yamaTheme === void 0 ? void 0 : yamaTheme.components) === null || _s === void 0 ? void 0 : _s.MuiFormGroup,
            MuiFormLabel: (_t = yamaTheme === null || yamaTheme === void 0 ? void 0 : yamaTheme.components) === null || _t === void 0 ? void 0 : _t.MuiFormLabel,
            MuiFormControl: (_u = yamaTheme === null || yamaTheme === void 0 ? void 0 : yamaTheme.components) === null || _u === void 0 ? void 0 : _u.MuiFormControl,
            MuiFormHelperText: (_v = yamaTheme === null || yamaTheme === void 0 ? void 0 : yamaTheme.components) === null || _v === void 0 ? void 0 : _v.MuiFormHelperText,
            MuiIconButton: (_w = yamaTheme === null || yamaTheme === void 0 ? void 0 : yamaTheme.components) === null || _w === void 0 ? void 0 : _w.MuiIconButton,
            MuiInput: (_x = yamaTheme === null || yamaTheme === void 0 ? void 0 : yamaTheme.components) === null || _x === void 0 ? void 0 : _x.MuiInput,
            MuiInputBase,
            MuiInputLabel: (_y = yamaTheme === null || yamaTheme === void 0 ? void 0 : yamaTheme.components) === null || _y === void 0 ? void 0 : _y.MuiInputLabel,
            MuiLink: (_z = yamaTheme === null || yamaTheme === void 0 ? void 0 : yamaTheme.components) === null || _z === void 0 ? void 0 : _z.MuiLink,
            MuiList: (_0 = yamaTheme === null || yamaTheme === void 0 ? void 0 : yamaTheme.components) === null || _0 === void 0 ? void 0 : _0.MuiList,
            MuiListItem: (_1 = yamaTheme === null || yamaTheme === void 0 ? void 0 : yamaTheme.components) === null || _1 === void 0 ? void 0 : _1.MuiListItem,
            MuiListItemButton: (_2 = yamaTheme === null || yamaTheme === void 0 ? void 0 : yamaTheme.components) === null || _2 === void 0 ? void 0 : _2.MuiListItemButton,
            MuiListSubheader: (_3 = yamaTheme === null || yamaTheme === void 0 ? void 0 : yamaTheme.components) === null || _3 === void 0 ? void 0 : _3.MuiListSubheader,
            MuiListItemIcon: (_4 = yamaTheme === null || yamaTheme === void 0 ? void 0 : yamaTheme.components) === null || _4 === void 0 ? void 0 : _4.MuiListItemIcon,
            MuiListItemText: (_5 = yamaTheme === null || yamaTheme === void 0 ? void 0 : yamaTheme.components) === null || _5 === void 0 ? void 0 : _5.MuiListItemText,
            MuiCircularProgress: (_6 = yamaTheme === null || yamaTheme === void 0 ? void 0 : yamaTheme.components) === null || _6 === void 0 ? void 0 : _6.MuiCircularProgress,
            MuiMenu: (_7 = yamaTheme === null || yamaTheme === void 0 ? void 0 : yamaTheme.components) === null || _7 === void 0 ? void 0 : _7.MuiMenu,
            MuiMenuItem: (_8 = yamaTheme === null || yamaTheme === void 0 ? void 0 : yamaTheme.components) === null || _8 === void 0 ? void 0 : _8.MuiMenuItem,
            MuiPaginationItem,
            MuiPaper: (_9 = yamaTheme === null || yamaTheme === void 0 ? void 0 : yamaTheme.components) === null || _9 === void 0 ? void 0 : _9.MuiPaper,
            MuiPopper,
            MuiPopover: (_10 = yamaTheme === null || yamaTheme === void 0 ? void 0 : yamaTheme.components) === null || _10 === void 0 ? void 0 : _10.MuiPopover,
            MuiRadio,
            MuiSelect: (_11 = yamaTheme === null || yamaTheme === void 0 ? void 0 : yamaTheme.components) === null || _11 === void 0 ? void 0 : _11.MuiSelect,
            MuiSlider: (_12 = yamaTheme === null || yamaTheme === void 0 ? void 0 : yamaTheme.components) === null || _12 === void 0 ? void 0 : _12.MuiSlider,
            MuiSnackbar: (_13 = yamaTheme === null || yamaTheme === void 0 ? void 0 : yamaTheme.components) === null || _13 === void 0 ? void 0 : _13.MuiSnackbar,
            MuiSnackbarContent: (_14 = yamaTheme === null || yamaTheme === void 0 ? void 0 : yamaTheme.components) === null || _14 === void 0 ? void 0 : _14.MuiSnackbarContent,
            MuiSwitch: (_15 = yamaTheme === null || yamaTheme === void 0 ? void 0 : yamaTheme.components) === null || _15 === void 0 ? void 0 : _15.MuiSwitch,
            MuiTab: (_16 = yamaTheme === null || yamaTheme === void 0 ? void 0 : yamaTheme.components) === null || _16 === void 0 ? void 0 : _16.MuiTab,
            MuiTabs: (_17 = yamaTheme === null || yamaTheme === void 0 ? void 0 : yamaTheme.components) === null || _17 === void 0 ? void 0 : _17.MuiTabs,
            MuiTable: (_18 = yamaTheme === null || yamaTheme === void 0 ? void 0 : yamaTheme.components) === null || _18 === void 0 ? void 0 : _18.MuiTable,
            MuiTableBody: (_19 = yamaTheme === null || yamaTheme === void 0 ? void 0 : yamaTheme.components) === null || _19 === void 0 ? void 0 : _19.MuiTableBody,
            MuiTableCell: (_20 = yamaTheme === null || yamaTheme === void 0 ? void 0 : yamaTheme.components) === null || _20 === void 0 ? void 0 : _20.MuiTableCell,
            MuiTableContainer: (_21 = yamaTheme === null || yamaTheme === void 0 ? void 0 : yamaTheme.components) === null || _21 === void 0 ? void 0 : _21.MuiTableContainer,
            MuiTableHead: (_22 = yamaTheme === null || yamaTheme === void 0 ? void 0 : yamaTheme.components) === null || _22 === void 0 ? void 0 : _22.MuiTableHead,
            MuiTableRow: (_23 = yamaTheme === null || yamaTheme === void 0 ? void 0 : yamaTheme.components) === null || _23 === void 0 ? void 0 : _23.MuiTableRow,
            MuiTextField: (_24 = yamaTheme === null || yamaTheme === void 0 ? void 0 : yamaTheme.components) === null || _24 === void 0 ? void 0 : _24.MuiTextField,
            MuiToggleButton,
            MuiTooltip: (_25 = yamaTheme === null || yamaTheme === void 0 ? void 0 : yamaTheme.components) === null || _25 === void 0 ? void 0 : _25.MuiTooltip,
            MuiTypography,
        },
        typography: Object.assign(Object.assign({}, yamaTheme.typography), { h3: Object.assign(Object.assign({}, yamaTheme.typography.h3), { color: yamaTokens.YamaPaletteTextSecondaryColor }), subtitle1: Object.assign(Object.assign({}, yamaTheme.typography.subtitle1), { color: yamaTokens.YamaPaletteTextSecondaryColor }), subtitle2: Object.assign(Object.assign({}, yamaTheme.typography.subtitle2), { color: yamaTokens.YamaPaletteTextSecondaryColor }) }),
        spacing: exports.SPACING_FACTOR,
        palette: yamaTheme.palette,
    });
};
exports.getCybertronTheme = getCybertronTheme;
exports.default = exports.getCybertronTheme;
